export function serviceToStateCallbackFactory(state, path, callback) {
  return (err, res) => {
    if (err) return callback(err);
    state.set(path, res);
    return callback(null, res);
  };
}
